// extracted by mini-css-extract-plugin
module.exports = {"Thead":"TableHeader_Thead__1Vi4X","Th":"TableHeader_Th__3EO_K"};